import { BaseSearchModel } from "../query/base-search.model";

export class  ContactSearchModal extends BaseSearchModel {
    firstName?: string;
    phoneNumber?: string;
    lastName?: string;
    fullName?: string;
    faxNumber?: string;
    email?: string;
    companyName?: string;
    createdById?: string; 
    number?: string;
}
